<template lang="pug">
  .checkout-page.page-left-right.grid(:class="[ grid, { 'page-leave-active page-leave-to': leave } ]")
    .col.left-area
      affix.sticky-stuff(
        ref="left"
        relative-element-selector=".scroll-area"
        :enabled="sticky"
        :scroll-affix="true"
        :offset="{ top: 0, bottom: 0 }"
      )
        slot(name="header")
        main(v-if="left.length")
          section(
            v-for="(section, index) in left"
            :key="section.id"
            :class="section.key"
          )
            Heading(v-if="section.key === 'heading'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            CheckoutStepper(v-if="section.key === 'checkout'" :section="section")
            //- Banner(v-if="section.key === 'banner'" :section="section")
            //- Slider(v-if="section.key === 'slider'" :section="section")
    .scroll-area(ref="scroll")
    .col.right-area(v-if="right.length")
      affix.sticky-stuff(
        ref="right"
        relative-element-selector=".scroll-area"
        :enabled="sticky"
        :scroll-affix="true"
        :offset="{ top: 0, bottom: 0 }"
      )
        section(
          v-for="(section, index) in right"
          :key="section.id"
          :class="section.key"
        )
          Post(v-if="section.key === 'post'" :section="section")
    slot(name="footer")
</template>
<script>
// import { mapGetters } from 'vuex';

import ContentPage from '@/views/ContentPage';

import Authenticate from '@/extensions/restricted-area/components/Authenticate';
import CheckoutStepper from '@/extensions/shop/components/CheckoutStepper';

export default {
    name: 'CheckoutPage',
    extends: ContentPage,
    components: {
        Authenticate,
        CheckoutStepper
    },
    computed: {
        left() {
            let sections = [];
            if (this.areas.left && this.areas.left.length) {
                const supported = ['heading', 'post', 'checkout'];
                sections = this.areas.left.filter(el => supported.includes(el.key));
            }
            return sections;
        },
        right() {
            let sections = [];
            if (this.areas.right && this.areas.right.length) {
                const supported = ['post'];
                sections = this.areas.right.filter(el => supported.includes(el.key));
            }
            return sections;
        }
    }
};
</script>
<style lang="sass" nolang="scss" scoped>
// @import "~@/assets/sass/variables"

section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
